import script from "./CampaignsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./CampaignsTable.vue?vue&type=script&setup=true&lang=ts"

import "./CampaignsTable.vue?vue&type=style&index=0&id=d95755d8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d95755d8"]])

export default __exports__